import { useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();
  
  return (
    <div className="relative flex flex-col items-center justify-center h-screen text-center px-4 bg-background-50">
      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-background-200 select-none pointer-events-none z-0">
        404
      </h1>
      <div className="relative z-10">
        <h1 className="text-xl md:text-2xl font-semibold mt-6 text-foreground-950 font-heading">ページが見つかりません</h1>
        <p className="mt-2 text-base text-foreground-600 font-mono">{location.pathname}</p>
        <p className="mt-4 text-lg md:text-xl text-foreground-500">お探しのページは存在しないか、移動された可能性があります。</p>
        <a href="/" className="mt-8 inline-block px-6 py-3 bg-primary-500 text-background-50 rounded-md font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer">
          ホームに戻る
        </a>
      </div>
    </div>
  )
}